import { Dialog_Header_default } from "./chunk-TFQ4SHEJ.js";
import { Dialog_Panel_default } from "./chunk-LE7PUXYA.js";
import { Dialog_default } from "./chunk-YQLMAWUZ.js";
import { Dialog_Backdrop_default } from "./chunk-KT4TCTET.js";
import { Dialog_Content_default } from "./chunk-NXKVYDCI.js";
import { Dialog_Front_default } from "./chunk-T3R7FYDN.js";

// src/components/Dialog/index.ts
var DialogComponent = Dialog_default;
DialogComponent.Backdrop = Dialog_Backdrop_default;
DialogComponent.Backdrop.displayName = "Dialog.Backdrop";
DialogComponent.Content = Dialog_Content_default;
DialogComponent.Content.displayName = "Dialog.Content";
DialogComponent.Front = Dialog_Front_default;
DialogComponent.Front.displayName = "Dialog.Front";
DialogComponent.Panel = Dialog_Panel_default;
DialogComponent.Panel.displayName = "Dialog.Panel";
DialogComponent.Header = Dialog_Header_default;
DialogComponent.Header.displayName = "Dialog.Header";
export { DialogComponent };